import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

// Dark navy page header used by every inner page. `breadcrumbs` mirrors the BreadcrumbList
// structured data passed to <SEO /> so the visible trail and the markup match.
// `bg` is a photo held static behind a navy overlay while the header content scrolls over it.
function PageHero({ breadcrumbs, kicker, title, text, actions, image, bg = '/images/bg-warehouse.jpg', children }) {
  return (
    <section
      className={`page-hero hero-bg${image ? ' page-hero-with-image' : ''}`}
      data-track-location="page_hero"
      style={bg ? { '--hero-bg': `url(${bg})` } : undefined}
    >
      <div className="container page-hero-inner">
        <div className="page-hero-copy animate-fade-in-up">
          {breadcrumbs && breadcrumbs.length > 0 && (
            <nav className="page-hero-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              {breadcrumbs.map((crumb, i) =>
                i === breadcrumbs.length - 1 ? (
                  <span key={crumb.path} aria-current="page">{crumb.name}</span>
                ) : (
                  <Link key={crumb.path} to={crumb.path}>{crumb.name}</Link>
                )
              )}
            </nav>
          )}
          {kicker && <span className="kicker">{kicker}</span>}
          <h1>{title}</h1>
          {text && <p className="page-hero-text">{text}</p>}
          {actions && <div className="btn-row page-hero-actions">{actions}</div>}
          {children}
        </div>
        {image && (
          <div className="page-hero-media">
            <img
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              fetchpriority="high"
            />
            {image.badge}
          </div>
        )}
      </div>
    </section>
  );
}

export default PageHero;
